import React, { ForwardedRef, forwardRef, memo, useMemo } from 'react';
import {
  FieldComponentType,
  RegistrationFieldProps,
} from './RegistrationField.types';
import DefaultField from './FieldComponents/DefaultField/DefaultField';
import { Box, Text, TextInput } from '@bonanza-social/moonlight';
import buildFieldComponents from './FieldComponents';
import { useSelector } from '@bonanza-social/toolkit/state';
import { selectRegistrationConfigVariant } from '../../state';
import { RegistrationVariantEnum } from '../../utils/fetchRegistrationVariant';

function RegistrationField(
  props: RegistrationFieldProps,
  ref: ForwardedRef<TextInput>,
) {
  const variant =
    useSelector(selectRegistrationConfigVariant) ??
    RegistrationVariantEnum.elevenStep;
  const components = useMemo(() => buildFieldComponents(variant), [variant]);
  const FieldComponent = useMemo(
    () =>
      (props.name
        ? (components[
            props.name as keyof typeof components
          ] as FieldComponentType)
        : null) ?? DefaultField,
    [props.name, components],
  );
  const hideGenericError = props.hideGenericError ?? false;
  const displayableError =
    typeof props.error === 'string' && !hideGenericError ? props.error : null;

  return (
    <Box>
      <FieldComponent ref={ref} {...props} />
      {displayableError ? (
        <Text color="darkSurfaceError" variant="body-m" marginTop="space-200">
          {displayableError}
        </Text>
      ) : null}
      {!displayableError && props.footerNS && props.footerKey ? (
        <Text
          variant="body-s"
          color="darkSurfaceSecondary"
          locNS={props.footerNS}
          locKey={props.footerKey}
          marginTop="space-200"
        ></Text>
      ) : null}
    </Box>
  );
}

export default memo(forwardRef(RegistrationField));
